import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ClipboardCheck, ListChecks, Star } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cache module → tests liés (QCM / évaluations), partagé entre fiches
let cache = null;
export const useTestsLies = () => {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    axios.get(`${API_URL}/modules-tests-lies`).then(r => { cache = r.data || {}; setMap(cache); }).catch(() => setMap({}));
  }, []);
  return map;
};

export const TestBadge = ({ t, compact }) => (
  <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] ${t.is_cle ? 'bg-amber-100 text-amber-900 border border-amber-300 font-semibold' : t.type === 'qcm' ? 'bg-indigo-50 text-indigo-700' : 'bg-violet-50 text-violet-700'}`}
    title={`${t.sous_type} · ${t.titre}${t.is_cle ? ' · test clé' : ''}`} data-testid={`test-lie-${t.test_id}`}>
    {t.is_cle && <Star className="w-2.5 h-2.5 fill-amber-500 text-amber-500" />}
    {t.type === 'qcm' ? <ClipboardCheck className="w-3 h-3" /> : <ListChecks className="w-3 h-3" />}
    <span className="uppercase">{t.type === 'qcm' ? 'QCM' : (t.sous_type || 'Éval')}</span>
    {!compact && <span className="font-normal truncate max-w-[220px]">{t.titre}</span>}
  </span>
);

// Liste des tests liés d'un module (fiche formation)
export const TestsLiesModule = ({ moduleId, compact = false }) => {
  const map = useTestsLies();
  const tests = map[moduleId] || [];
  if (tests.length === 0) return compact ? null : <p className="text-[10px] text-slate-400 italic">Aucun QCM / évaluation lié</p>;
  return <div className="flex flex-wrap gap-1" data-testid={`tests-lies-${moduleId}`}>{tests.map(t => <TestBadge key={t.test_id} t={t} compact={compact} />)}</div>;
};
